export enum INVOICE_REQUEST_STATUS_LABEL {
    SUBMITTED = 'Submitted',
    COMPLETED = 'Completed',
    REJECTED = 'Rejected',
    NOT_SUBMITTED = 'Not Submitted',
    DRAFT = 'Draft',
}

/** MST INV_TYPE codeId for "Demurrage / Detention Invoice" (CI / liner 24118) */
export const DEMURRAGE_DETENTION_INVOICE_TYPE_CODE = 103;
